import React, { Component } from 'react'
import { consulta, rutaImg, api, obtenerValoresFiltros } from "../../../global/js/funciones";
import ListarDatos from '../../general/ListarDatos';
import { BtnRegresar} from '../../general/BotonesAccion'
import { Box, Tooltip, IconButton } from '@material-ui/core';
import { PDFDownloadLink, Document, Page, Text, View, Image, StyleSheet   } from '@react-pdf/renderer';
import GetAppIcon from '@material-ui/icons/GetApp';
import moment from 'moment';
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from '../../../global/imagenes/emma_w.png';
import LogoCuc from '../../../global/imagenes/logo_cuc3.png';


class AdminCertificado extends Component {
constructor(props) {
    super(props)
    this.state = {
    dato_buscar: '',
    cargando: false,
    personas: [],
    generica: {
        tipo: 0,
        id: 0,
    },
    modal: false,
    id_persona: null,
    cordinador: '',
    firma_coordinador: '',
    }
}

componentDidMount() {
    this.obtenerNombreJefes();
}

obtenerNombreJefes = async () => {
    let nombrejefe = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'firma_coordinador' }]);
    if (nombrejefe && nombrejefe[0]) {
      this.setState({ cordinador: nombrejefe[0].valora, firma_coordinador: nombrejefe[0].archivo });
    }
}
styles = StyleSheet.create({
    body: {
    border: '1.1px solid #DFDDDD',
    width: '100%',
    height: '100%',
    paddingBottom: '60px',
    paddingLeft: '45px',
    paddingRight: '45px'
    },
    imagen: {
    width: '100%',
    display: 'flex',
    margin: '20px 0 20px 0',
    justifyContent: 'center',
    alignItems: 'center'
    },
    img: {
    objectFit: 'cover',
    width: '200px'
    },
    titular: {
    fontSize: '12px',
    textAlign: 'center',
    margin: '10px 0 10px 0',
    fontFamily: 'PTSerifBold',

    },
    negrita: {
    fontFamily: 'PTSerifBold',
    lineHeight: 1.3,
    textAlign: 'justify',
    },
    parrafo: {
    fontSize: '12px',
    margin: '20px 0 0 0',
    textAlign: 'justify',
    lineHeight: 1.3,
    },
    parrafo1: {
    fontSize: '12px',
    margin: '70px 0 0 0',
    textAlign: 'justify',
    },
    firma: {
    paddingLeft: '10px',
    width: '100px',
    height: '135px',
    display: 'flex',
    margin: '35px 0 -80px -5px'
    },
    piefirma: {
    fontFamily: 'PTSerifBold',
    fontSize: '13px',
    },
    piefirma1: {
        fontSize: '9px',
        textAlign: 'justify',
        lineHeight: 1.3,
    },
    
    informacion: {
    textAlign: 'justify',
    fontSize: '11px',
    color: 'lightcoral',
    margin: '150px 0 0 0',
    },
    linea: {
    margin: '-20px 0 0 0',
    }
});

componentDidUpdate(prevProps, prevState) {
    if (this.state.dato_buscar !== prevState.dato_buscar) {
      if (this.state.dato_buscar.length > 5) {
        this.obtenerGestores(this.state.dato_buscar);
      } else {
        this.setState({ personas: [], cargando: false });
      }
    }
  }
  

 obtenerGestores = (dato) => {
    this.setState({ cargando: true })
    if (dato.length > 5) {
    consulta(`api/v1.0/investigacion/ListarRetirados`, { dato }, "post",
        (error, estado, resp) => {
          if (estado === 200) {
            this.setState({ cargando: false, personas: resp })
          }
        }
      );
    } this.setState({ cargando: false, personas: [] });
  }

obtenerMes = (mes) => {
    const meses = {
    '1': 'Enero',
    '2': 'Febrero',
    '3': 'Marzo',
    '4': 'Abril',
    '5': 'Mayo',
    '6': 'Junio',
    '7': 'Julio',
    '8': 'Agosto',
    '9': 'Septiembre',
    '10': 'Octubre',
    '11': 'Noviembre',
    '12': 'Diciembre'
    }
    return (meses[mes])
}
generarPDF_certificado = (data) => {
    console.log( 'esta es la dataaaaa',data)
    let fecha_actual = moment()
    let hoy = `${fecha_actual.format('D')} de ${this.obtenerMes(fecha_actual.format('M'))} de ${fecha_actual.format('YYYY')}`
    let persona = data.encargado_id || data;
    let nombre = `${persona.primer_nombre} ${persona.segundo_nombre} ${persona.primer_apellido} ${persona.segundo_apellido}` ||`${data.primer_nombre} ${data.segundo_nombre} ${data.primer_apellido} ${data.segundo_apellido}`;
    let fechainicio =data.fecha_registro.split("T")[0];
    let fechafinal = (data.fecha_elimina || '').split("T")[0];
    let cedula = persona.identificacion || data.usuario_registro.identificacion
    let semillero = data.semillero.nombre
    let firma = this.state.cordinador || this.props.cordinador
    let imgfirma = this.state.firma_coordinador
    let srcFirma = imgfirma ? (imgfirma.startsWith('http') ? imgfirma : `${api}${imgfirma}`) : null
    let rol = data?.rol?.nombre || "Participante";
    

    console.log(data);
    return (
    <Document>
        <Page size="A4">
        <View style={this.styles.body}>
            <View style={this.styles.imagen}>
            <Image style={this.styles.img} src={LogoCuc} alt="images" />
            </View>
            <Text style={this.styles.titular}>A QUIEN INTERESE</Text>
            <Text style={this.styles.parrafo}>
            El suscrito Coordinador Semilleros De Investigación e Innovación de la Corporación Universidad de la Costa, certifica que <Text style={this.styles.negrita}>{nombre}</Text> identificado(a) con la Cédula de Ciudadanía No.<Text style={this.styles.negrita}>{cedula}</Text>, pertenecío al Semillero de Investigación. <Text style={this.styles.negrita}>{semillero} </Text> con el rol de: <Text style={this.styles.negrita}>{rol}</Text> desde el <Text style={this.styles.negrita}>{fechainicio}</Text>
            <Text> {fechafinal ? "hasta " : ""}</Text>
            <Text style={this.styles.negrita}>{fechafinal}</Text>.
            </Text>
            <Text style={this.styles.parrafo}>Se expide el presente certificado en Barranquilla, Colombia el {hoy}</Text>
            <Text style={this.styles.parrafo1}>Atentamente, </Text>

            <View style={this.styles.firma}>
            {srcFirma && <Image src={srcFirma} />}
            </View>
            <Text style={this.styles.linea}>_____________________</Text>
            <Text style={this.styles.piefirma}>{firma} </Text>
            <Text style={this.styles.piefirma1}> Coordinación de semilleros de investigación e innovación </Text>
            <Text style={this.styles.piefirma1}> Vicerrectoría de Ciencia, Tecnología e Innovación </Text>
            <Text style={this.styles.informacion}>
            Calle 58 N° 55-66 – Teléfonos: (5) 336 2200 – 3441974 – Fax: 3442670 – A.A. 50366 – www.cuc.edu.co
            </Text>
        </View>
        </Page>
    </Document>
    )
}

acciones(data) {
    let persona = data.encargado_id || data;
    const descargar = (
    <Box style={{ display: 'flex', justifyContent: 'space-evenly', marginLeft: 'auto' }}>
        <PDFDownloadLink
        style={{ textDecoration: 'none' }}
        document={this.generarPDF_certificado(data)}
        fileName={`certificado_${data.identificacion || persona.identificacion}.pdf`}
        >
        {({ loading }) => (
            <Tooltip title="Descargar Certificado">
            <IconButton style={{ color: '#2196f3' }} aria-label="download">
                <GetAppIcon fontSize="small" />
            </IconButton>
            </Tooltip>
        )}
        </PDFDownloadLink>
    </Box>
    );

    return <div>{descargar}</div>;
}


render(){
    let { dato_buscar, cargando, personas } = this.state;
    let { handleClicki } = this.props;
    let { mensajeVacio } = this.props;
    if (cargando) return <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" />;
    return (
    <div>
        <div>
        <BtnRegresar className={'regresar'} callback={handleClicki}  />
        </div>
        <div>
    <ListarDatos
        id="tbl_becas_permisos"
        titulo='Lista de participantes de semilleros retirados'
        datos={personas}
        opciones={true}
        buscar={true}
        cargando={cargando}
        mensajeVacio={mensajeVacio ? mensajeVacio : 'Esta bandeja esta vacía, ingrese dato a buscar'}
        acciones={row => this.acciones(row)}
        avatarImg={true}
        actBuscar={(dato_buscar) => this.setState({ dato_buscar })}
        datoBuscarAlt={dato_buscar}
        avatar={({ identificacion }) => `${rutaImg}${identificacion}.jpg`}
        fila_principal={row => {
            const persona = row.encargado_id || row; 
            return `${persona.primer_nombre} ${persona.segundo_nombre} ${persona.primer_apellido} ${persona.segundo_apellido}`.toUpperCase();
        }}        filas={[
        { 'mostrar': ({ correo, encargado_id}) => `${correo || encargado_id?.correo}`, 'id': 'correo', 'enLista': true },
        { 'mostrar': ({ identificacion, encargado_id }) => `${identificacion || encargado_id?.identificacion}`, 'id': 'identificacion', 'enLista': true }
        ]}
    />
    </div>
    </div>
    )
}
}


export default AdminCertificado